import React, { useMemo, useState, useEffect, useRef } from 'react';
import { ShowMessageCommandTypes } from '../../commands/practitioner/enums/ShowMessageCommandTypes';
import childVoc from '../../assets/showAidMessage/defaultVOC.png';
import childSud from '../../assets/showAidMessage/defaultSUD.png';
interface ModalAidMessageContentAdultProps {
  messageType: ShowMessageCommandTypes;
}

export function ModalAidMessageContentAdult(props: ModalAidMessageContentAdultProps) {
  const { messageType } = props;
  const renderChild = useMemo(() => {
    switch (messageType) {
      case ShowMessageCommandTypes.Sud:
        return <img src={childSud} />;
      case ShowMessageCommandTypes.Voc:
        return <img src={childVoc} />;
      default:
        return;
    }
  }, [messageType]);

  return <>{renderChild}</>;
}
